/**
 * Argon2 Worker のインスタンス生成。
 *
 * Vite が `new URL('./argon2.worker.ts', import.meta.url)` を検出して
 * 専用 worker chunk としてバンドルする (production build 互換)。
 *
 * 単独モジュールに分離している理由:
 *   - vitest 環境 (Node) では Worker グローバルが無いため、テスト時に
 *     vi.mock でこのファイルを差し替えて FakeWorker を注入できるようにする。
 */
export const createArgon2Worker = (): Worker =>
  new Worker(new URL('./argon2.worker.ts', import.meta.url), {
    type: 'module',
    name: 'ookey-argon2-worker',
  })
